/**
 * Whether the page runs in a phone or tablet browser, where the native app may be installed and a
 * `suite-native://` link can open it. A user-agent test is enough: a wrong answer only shows or
 * hides one link.
 *
 * @returns True on iPhone, iPad and Android browsers.
 */
export function isPhoneBrowser() {
	if (typeof navigator === "undefined") return false;
	return /iPhone|iPad|Android/i.test(navigator.userAgent);
}
